import React, {
  useState,
  useEffect,
} from "react";
import rcsLogo from "../assets/rcslogo.png";
import {
  useParams,
  useNavigate,
} from "react-router-dom";

import "../Styles/AccountDetails.css";

import api from "../api";

import {
  toast,
} from "react-toastify";

import {
  Landmark,
  Wallet,
  ArrowDownCircle,
  ArrowUpCircle,
  Scale,
  Calendar,
  Search,
  Plus,
  ChevronLeft,
  FileText,
  Trash2,
  Pencil,
  ArrowRightLeft,
} from "lucide-react";

import EditTransactionModal from "../Components/EditTransactionModal";

import {
  getGuyanaDate,
} from "../utils/timezone";

const AccountDetails = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const [account, setAccount] =
    useState(null);

  const [transactions, setTransactions] =
    useState([]);

  const [loading, setLoading] =
    useState(true);


const [
  transactionLoading,
  setTransactionLoading,
] = useState(false);


  const [search, setSearch] =
    useState("");

  const [editingTransaction,
    setEditingTransaction] =
    useState(null);

  const [selectedMonth,
    setSelectedMonth] =
    useState(() => {

      const now = new Date();

      return `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}`;

    });

  const [newTransaction,
    setNewTransaction] =
    useState({
      date: getGuyanaDate(),
      debit: "",
      credit: "",
      details: "",
      counterAccountId: "",
    });

  const [accountList,
    setAccountList] =
    useState([]);

  // =====================================
  // FETCH
  // =====================================

  useEffect(() => {

    const loadData = async () => {

      try {

        setLoading(true);

        const accounts =
          await api.getAccounts();

        setAccountList(accounts);

        const current =
          accounts.find(
            (a) =>
              a.id === parseInt(id)
          );

const allTransactions =
  await api.getTransactions(id);

const runningDebits =
  allTransactions.reduce(
    (sum, txn) =>
      sum + Number(txn.debit || 0),
    0
  );

const runningCredits =
  allTransactions.reduce(
    (sum, txn) =>
      sum + Number(txn.credit || 0),
    0
  );

const runningBalance =
  runningDebits - runningCredits;

setAccount({
  ...current,
  balance: runningBalance,
});


        const [year, month] =
          selectedMonth.split("-");

        const txnData =
          await api.getTransactionsByMonth(
            id,
            year,
            month
          );

        setTransactions(txnData);

      } catch (err) {

        console.error(err);

        toast.error(
          "Failed to load account."
        );

      } finally {

        setLoading(false);

      }

    };

    loadData();

  }, [id, selectedMonth]);

// =====================================
// TOTALS
// =====================================

const totalDebits =
  transactions.reduce(
    (sum, txn) =>
      sum + Number(txn.debit || 0),
    0
  );

const totalCredits =
  transactions.reduce(
    (sum, txn) =>
      sum + Number(txn.credit || 0),
    0
  );

// ✅ TRUE RUNNING BALANCE
const accountBalance =
  Number(account?.balance || 0);

const balanceType =
  accountBalance >= 0
    ? "Debit"
    : "Credit";

  // =====================================
  // FILTER
  // =====================================

  const filteredTransactions =
    transactions.filter((txn) =>
      txn.details
        ?.toLowerCase()
        .includes(
          search.toLowerCase()
        )
    );

  // =====================================
  // ADD TXN
  // =====================================

  const handleAddTransaction =
    async () => {

      try {

        if (
          !newTransaction.debit &&
          !newTransaction.credit
        ) {
          toast.warning(
            "Enter debit or credit."
          );
          return;
        }

        const referenceId =
          `TXN-${Date.now()}`;

        const mainTxn = {
          date:
            newTransaction.date,

          debit:
            newTransaction.debit
              ? parseFloat(
                  newTransaction.debit
                )
              : 0,

          credit:
            newTransaction.credit
              ? parseFloat(
                  newTransaction.credit
                )
              : 0,

          details:
            newTransaction.details,

          reference_id:
            referenceId,
        };

        const counterTxn = {
          date:
            newTransaction.date,

          debit:
            newTransaction.credit
              ? parseFloat(
                  newTransaction.credit
                )
              : 0,

          credit:
            newTransaction.debit
              ? parseFloat(
                  newTransaction.debit
                )
              : 0,

          details:
            newTransaction.details,

          reference_id:
            referenceId,
        };

        await Promise.all([
          api.addTransaction(
            id,
            mainTxn
          ),

          api.addTransaction(
            newTransaction.counterAccountId,
            counterTxn
          ),
        ]);

        toast.success(
          "Transaction added."
        );

        setTransactionLoading(true);

setTimeout(() => {
  window.location.reload();
}, 1400);

      } catch (err) {

        toast.error(
          "Failed to add transaction."
        );

      }

    };

  // =====================================
  // DELETE
  // =====================================

  const handleDelete =
    async (txnId) => {

      if (
        !window.confirm(
          "Delete transaction?"
        )
      )
        return;

      try {

        await api.deleteTransaction(
          txnId
        );

        setTransactions((prev) =>
          prev.filter(
            (t) => t.id !== txnId
          )
        );

        toast.success(
          "Deleted successfully."
        );

      } catch {

        toast.error(
          "Delete failed."
        );

      }

    };

if (loading) {

  return (

    <div className="account-details-loading-screen">

      <div className="account-details-loader-container">

        {/* GLOW */}

        <div className="account-details-loader-glow" />

        {/* SPINNER */}

        <div className="account-details-loader-spinner">

          {/* PRIMARY RING */}

          <div className="account-details-loader-ring" />

          {/* SECONDARY RING */}

          <div className="account-details-loader-ring-secondary" />

          {/* LOGO */}

          <div className="account-details-loader-logo">

            <img
              src={rcsLogo}
              alt="RCS Logo"
            />

          </div>

        </div>

        {/* TEXT */}

        <div className="account-details-loader-text">

          <h2>
            Loading Account
          </h2>

          <p>
            Preparing ledger,
            balances and
            transaction history...
          </p>

        </div>

      </div>

    </div>
  );
}


if (transactionLoading) {

  return (

    <div className="account-details-loading-screen">

      <div className="account-details-loader-container">

        {/* GLOW */}

        <div className="account-details-loader-glow" />

        {/* SPINNER */}

        <div className="account-details-loader-spinner">

          <div className="account-details-loader-ring" />

          <div className="account-details-loader-ring-secondary" />

          <div className="account-details-loader-logo">

            <img
              src={rcsLogo}
              alt="RCS Logo"
            />

          </div>

        </div>

        {/* TEXT */}

        <div className="account-details-loader-text">

          <h2>
            Processing Transaction
          </h2>

          <p>
            Updating balances,
            journals and ledger
            records...
          </p>

        </div>

      </div>

    </div>
  );
}

  return (

    <div className="account-page">

      {/* =========================
          HERO
      ========================== */}

      <div className="account-hero">

        <div className="account-hero-left">

          <div className="account-badge">
            <Landmark size={15} />
            <span>
              Financial Account
            </span>
          </div>

          <div className="account-title-wrap">

            <div className="account-icon">
              <Wallet size={40} />
            </div>

            <div>

              <h1>
                {account?.name}
              </h1>

              <p>
                Double-entry
                accounting ledger
              </p>

            </div>

          </div>

        </div>

        <div className="account-hero-actions">

          <button
            className="hero-btn secondary"
            onClick={() =>
              navigate("/accounts")
            }
          >
            <ChevronLeft size={18} />
            Back
          </button>

          <button
            className="hero-btn primary"
          >
            <FileText size={18} />
            Generate Report
          </button>

        </div>

      </div>

      {/* =========================
          SUMMARY
      ========================== */}

      <div className="summary-grid">

        <div className="summary-card">

          <div className="summary-icon teal">
            <Scale size={22} />
          </div>

          <div>

            <p>
              Account Balance
            </p>

            <h3>
              $
              {Math.abs(
                accountBalance
              ).toLocaleString()}
            </h3>

<span
  className={
    balanceType === "Debit"
      ? "positive"
      : "negative"
  }
>
  {balanceType}
</span>

          </div>

        </div>

        <div className="summary-card">

          <div className="summary-icon green">
            <ArrowDownCircle
              size={22}
            />
          </div>

          <div>

            <p>Total Debits</p>

            <h3>
              $
              {totalDebits.toLocaleString()}
            </h3>

          </div>

        </div>

        <div className="summary-card">

          <div className="summary-icon red">
            <ArrowUpCircle
              size={22}
            />
          </div>

          <div>

            <p>Total Credits</p>

            <h3>
              $
              {totalCredits.toLocaleString()}
            </h3>

          </div>

        </div>

        <div className="summary-card">

          <div className="summary-icon blue">
            <Calendar size={22} />
          </div>

          <div>

            <p>Period</p>

            <h3>
              {selectedMonth}
            </h3>

          </div>

        </div>

      </div>

      {/* =========================
          MAIN GRID
      ========================== */}

      <div className="ledger-layout">

        {/* =====================
            LEFT
        ====================== */}

        <div className="ledger-panel">

          <div className="ledger-topbar">

            <div className="search-box">

              <Search size={17} />

              <input
                type="text"
                placeholder="Search transactions..."
                value={search}
                onChange={(e) =>
                  setSearch(
                    e.target.value
                  )
                }
              />

            </div>

            <input
              type="month"
              value={selectedMonth}
              onChange={(e) =>
                setSelectedMonth(
                  e.target.value
                )
              }
              className="month-picker"
            />

          </div>

          <div className="ledger-table-wrap">

            <table className="ledger-table">

              <thead>

                <tr>
                  <th>Date</th>
                  <th>Reference</th>
                  <th>Details</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th>Actions</th>
                </tr>

              </thead>

              <tbody>

                {filteredTransactions.map(
                  (txn) => (

                    <tr key={txn.id}>

                      <td>
                        {txn.date
                          ?.split(
                            "T"
                          )[0]}
                      </td>

                      <td>
                        {
                          txn.reference_id
                        }
                      </td>

                      <td>
                        {txn.details}
                      </td>

                      <td className="debit-cell">
                        {txn.debit
                          ? `$${Number(
                              txn.debit
                            ).toLocaleString()}`
                          : "-"}
                      </td>

                      <td className="credit-cell">
                        {txn.credit
                          ? `$${Number(
                              txn.credit
                            ).toLocaleString()}`
                          : "-"}
                      </td>

                      <td>

<div className="table-actions">

  <button
    className="table-btn edit"
    onClick={() =>
      setEditingTransaction(txn)
    }
  >
    <Pencil size={14} />
    <span>Edit</span>
  </button>

  <button
    className="table-btn delete"
    onClick={() =>
      handleDelete(txn.id)
    }
  >
    <Trash2 size={14} />
    <span>Delete</span>
  </button>

</div>

                      </td>

                    </tr>

                  )
                )}

              </tbody>

            </table>

          </div>

        </div>

        {/* =====================
            RIGHT
        ====================== */}

        <div className="journal-sidebar">

          <div className="journal-card">

            <div className="journal-header">

              <h3>
                Journal Entry
              </h3>

              <ArrowRightLeft
                size={18}
              />

            </div>

            <div className="journal-form">

              <input
                type="date"
                value={
                  newTransaction.date
                }
                onChange={(e) =>
                  setNewTransaction({
                    ...newTransaction,
                    date:
                      e.target.value,
                  })
                }
              />

              <input
                type="number"
                placeholder="Debit"
                value={
                  newTransaction.debit
                }
                onChange={(e) =>
                  setNewTransaction({
                    ...newTransaction,
                    debit:
                      e.target.value,
                    credit: "",
                  })
                }
              />

              <input
                type="number"
                placeholder="Credit"
                value={
                  newTransaction.credit
                }
                onChange={(e) =>
                  setNewTransaction({
                    ...newTransaction,
                    credit:
                      e.target.value,
                    debit: "",
                  })
                }
              />

              <textarea
                placeholder="Transaction details"
                value={
                  newTransaction.details
                }
                onChange={(e) =>
                  setNewTransaction({
                    ...newTransaction,
                    details:
                      e.target.value,
                  })
                }
              />

              <select
                value={
                  newTransaction.counterAccountId
                }
                onChange={(e) =>
                  setNewTransaction({
                    ...newTransaction,
                    counterAccountId:
                      e.target.value,
                  })
                }
              >

                <option value="">
                  Select Counter
                  Account
                </option>

                {accountList
                  .filter(
                    (a) =>
                      a.id !==
                      parseInt(id)
                  )
                  .map((acc) => (

                    <option
                      key={acc.id}
                      value={acc.id}
                    >
                      {acc.name}
                    </option>

                  ))}

              </select>

              <button
                className="submit-journal-btn"
                onClick={
                  handleAddTransaction
                }
              >
                <Plus size={18} />
                Submit Transaction
              </button>

            </div>

          </div>

        </div>

      </div>

      {/* =========================
          EDIT MODAL
      ========================== */}

      <EditTransactionModal
        editingTransaction={
          editingTransaction
        }
        setEditingTransaction={
          setEditingTransaction
        }
      />

    </div>

  );

};

export default AccountDetails;